//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectFace.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"EndOffset",0,"Expression",0],[0,"ExcessType",1,0],[0,"ExtendEndFace",1,0],[0,"ExtendStartFace",1,0],[1,"OffsetDistance",0,"Expression",1],[0,"OffsetType",1,0],[1,"SelectFace",0,"SelectFace",1],[1,"SelectFaces",0,"ScCollector",0],[1,"StartOffset",0,"Expression",0],[0,"Type",1,0],[0,"Version",0,0]],[],[]];
SPLM.Features.ShipDesign.ExcessMaterialBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ExcessMaterialBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ExcessMaterialBuilder.VersionID = Object.freeze({
    "Original" : "Original", "Nx902" : "Nx902"});

SPLM.Features.ShipDesign.ExcessMaterialBuilder.Types = Object.freeze({
    "ExcessMaterial" : "ExcessMaterial", "FitUp" : "FitUp"});

SPLM.Features.ShipDesign.ExcessMaterialBuilder.Offset = Object.freeze({
    "Constant" : "Constant", "LinearVarying" : "LinearVarying"});

export default SPLM;